import { quartzConfig } from 'quartz-config/config-for-app';
import { invariant } from 'quartz/invariant';
invariant(quartzConfig.type === 'application');
if (
// @ts-expect-error $quartzConfigVal's types can't be narrowed, so any app-only config fields present as type errors
true !== false) {
  const {
    configureLogfetchErrors
  } =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('../internal/logfetch-error-monitoring');
  configureLogfetchErrors((quartzConfig === null || quartzConfig === void 0 ? void 0 : quartzConfig.logFetchErrors) || {});
}